module.exports = __webpack_public_path__ + "static/media/04-_DSC0914.87493192.jpg";